import React, { PureComponent, Fragment } from 'react';
import { Route, Link, Switch, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router';
import { Tabs } from 'neatui';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import action from 'ReduxModules/action';
import ajax from './util/ajax';
import { historyPush } from './util/publish';
import ChangePhone from './changePhone';
import FeedbackForm from './feedbackForm';
import FeedbackList from './feedbackList';
// import Skills from './skills';
// import Faqs from './faqs';
import global from '../common/global';
// import CustomerService from '../assets/svg/customerService';

const titleMap = {
  '/details/faq': '常见问题',
  '/details/skill': '运营技巧',
  '/details/feedback': '意见反馈',
  '/details/changePhone': '修改手机号',
  '/details/feedback-history': '我的反馈',
};
// const needLogin = ['/details/feedback', '/details/changePhone', '/details/feedback-history'];
class Details extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      unReadState: false,
    };
  }

  componentDidMount() {
    const value = window.location.hash.slice(1);
    if (titleMap[value])
      setTimeout(() => {
        document.title = `${titleMap[value]}-客服中心-网易号`;
        window.neteaseTracker && window.neteaseTracker();
      }, 100);
    // this.login(value);
    // todo 受反馈上线时间限制，先隐藏该部分
    const { initFeedbackList } = this.props;
    ajax(
      '/feedback/unread.do',
      {
        method: 'GET',
      },
      res => {
        initFeedbackList('unReadList', res.data);
        this.setState({
          unReadState: !!res.data.length,
        });
      },
      () => {},
      false,
      false,
      false,
    );
  }

  // login(value) {
  //   const { stone, updateCommon } = this.props;
  //   if (needLogin.includes(value)) {
  //     if (!(stone.user && stone.user.wemediaId)) {
  //       return ajax('/navinfo.do', {}, rs => {
  //         updateCommon('user', rs.data);
  //         return rs;
  //       });
  //     }
  //   }
  // }

  handleChange = (e, value) => {
    const { history } = this.props;
    historyPush(history, value);
    if (titleMap[value]) {
      document.title = `${titleMap[value]}-客服中心-网易号`;
      window.neteaseTracker && window.neteaseTracker();
    }
    // this.login(value);
  };

  openQiyu = () => {
    const { stone = {}, updateCommon } = this.props;
    if (stone.user && stone.user.wemediaId) {
      let param = {
        uid: stone.user.tid || '',
        name: stone.user.tname,
        robotShuntSwitch: 1, // 申请人工客服之前是否先申请机器人开关，0代表关闭，1代表启用。
        level: `${stone.user.accountQuality}`,
        data: JSON.stringify([
          {
            key: 'star',
            label: '星级',
            value: global.getLabelByValue('star', stone.user.star),
          },
          {
            key: 'accountQuality',
            label: '图文质量',
            value: global.getLabelByValue('accountLevelType', stone.user.accountQuality),
          },
          {
            key: 'videoQuality',
            label: '视频质量',
            value: global.getLabelByValue('accountLevelType', stone.user.videoQuality),
          },
          {
            key: 'authority',
            label: '运营权限',
            value: global.getLabelByValue('authority', stone.user.local),
          },
          {
            key: 'accountType',
            label: '账号类型',
            value: global.getLabelByValue('accountType', stone.user.accountType),
          },
        ]),
      };
      // 账号类型为自媒体且图文质量为中等、差、未审核、待定的用户，默认接入机器人，转人工时，接入空客服组，进入留言模式
      if (stone.user.accountType === 1 && [0, 1, 2, 5].indexOf(stone.user.accountQuality) !== -1) {
        param = Object.assign({}, param, { groupid: '398004088' });
        console.log(param);
      }
      window.ysf.on({
        onload: () => {
          window.ysf.config(param);
        },
      });
      window.ysf.open();
    } else {
      return ajax('/navinfo.do', {}, rs => {
        updateCommon('user', rs.data);
        return rs;
      });
    }
  };

  render() {
    const { match, stone = {} } = this.props;
    const { unReadState } = this.state;
    // const isLogin = stone && stone.user && stone.user.wemediaId;
    return (
      <Fragment>
        <h1 className="details-title">
          <Link to="/">网易号客服中心</Link>
        </h1>
        <Tabs defaultValue={match.url} onChange={this.handleChange} className="nav-bar">
          {/* <Tabs.Tab value="/details/faq">常见问题</Tabs.Tab> */}
          {/* <Tabs.Tab value="/details/skill">运营技巧</Tabs.Tab> */}
          <Tabs.Tab value="/details/feedback">意见反馈</Tabs.Tab>
          <Tabs.Tab value="/details/feedback-history">
            <span>我的反馈</span>
            {unReadState && <span className="nav-bar-circle" />}
          </Tabs.Tab>
          {stone && stone.user && (stone.user.onlineState <= 4 && stone.user.onlineState >= 1) ? (
            <Tabs.Tab value="/details/changePhone">修改手机号</Tabs.Tab>
          ) : null};
          {/* {stone.user && stone.user.wemediaId ? (
            <div className="service-tab" onClick={this.openQiyu}>
              <CustomerService color="#333" className="service-tab-logo" />
              <div className="service-tab-title">在线客服</div>
              <div className="service-tab-desc">工作时间在线服务 </div>
            </div>
          ) : null} */}
        </Tabs>
        <Switch>
          {/* <Route exact path="/details/faq" component={Faqs} /> */}
          {/* <Route exact path="/details/skill" component={Skills} /> */}
          <Route exact path="/details/feedback" component={FeedbackForm} />
          <Route exact path="/details/changePhone" component={ChangePhone} />
          <Route exact path="/details/feedback-history" component={FeedbackList} />
          <Redirect to="/details/faq" />
        </Switch>
      </Fragment>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      stone: state.common,
    }),
    dispatch =>
      bindActionCreators(
        {
          updateCommon: action.updateCommon,
          initFeedbackList: action.initFeedbackList,
        },
        dispatch,
      ),
  )(Details),
);
